import React from 'react';
import { useGoalsContext } from '../GoalsContext/GoalsContext';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { PeriodDropdown } from './PeriodDropdown';

export const GoalPeriodSelector: React.FC = () => {
  return (
    <div className="header mb-0 mt-md-3">
      <GoalPeriodContent />
    </div>
  );
};

const GoalPeriodContent: React.FC = () => {
  const { t } = useTranslation();

  const {
    allActivePeriods,
    loading,
    currentPeriod,
    setCurrentPeriodId,
    developmentFrameworkEnabled,
  } = useGoalsContext();

  if (loading) {
    return <Skeleton height={30} width={180} />;
  }

  if (!developmentFrameworkEnabled || allActivePeriods.length === 0) {
    return (
      <div className="header-body border-0 pb-3">
        <h1 className="header-title">
          {t('performanceReview.subMenuItems.goals.title')}
        </h1>
      </div>
    );
  }

  return (
    <PeriodDropdown
      periods={allActivePeriods}
      currentPeriod={currentPeriod}
      onSelect={setCurrentPeriodId}
      selectLabel={t('performanceReview.goals2.selectGoalsPeriod')}
    />
  );
};
